import { createApiCall } from "services/api";

import { transformToRequestRegister } from "./transformations";
import { RegistrationFormValues, LoginFormValues } from "./types";
import { transformErrorResponse } from "services/api/transformation";

export const logIn = async (
  formValues: LoginFormValues
): Promise<{ refreshToken: string; accessToken: string }> => {

  const resp = await createApiCall(
    {
      path: "/v1/users/authenticate",
      method: "POST",
      body: {
        username: formValues.email,
        password: formValues.password,
      },
    },
    {
      getMessage: {
        success: () => "Uspješno ste se prijavili! Dobro došli!",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return {
    refreshToken: resp.data.refreshToken,
    accessToken: resp.data.accessToken,
  };
};

/**
 * Prijava Google računom. `credential` je token koji Google preda pregledniku; poslužitelj ga
 * provjerava i vraća naše tokene, pa je nastavak isti kao kod prijave lozinkom.
 */
export const logInWithGoogle = async (
  credential: string
): Promise<{ refreshToken: string; accessToken: string }> => {
  const resp = await createApiCall(
    {
      path: "/v1/users/authenticate/google",
      method: "POST",
      body: { credential },
    },
    {
      getMessage: {
        success: () => "Uspješno ste se prijavili! Dobro došli!",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return {
    refreshToken: resp.data.refreshToken,
    accessToken: resp.data.accessToken,
  };
};

export const registerUser = async (
  formValues: RegistrationFormValues
): Promise<void> => {
  await createApiCall(
    {
      path: "/v1/users/register",
      method: "POST",
      body: transformToRequestRegister(formValues),
    },
    {
      getMessage: {
        success: () => "Uspješno ste se registrirali.",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();
};

export const requestPasswordChange = async (email: string): Promise<void> => {
  await createApiCall(
    {
      path: "/v1/auth/register/reset_password",
      method: "POST",
      body: { email },
    },
    {
      getMessage: {
        success: () => "An email has been sent to you.",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();
};

export const changePassword = async (formValues: {
  email: string;
  verificationCode: string;
  password: string;
}): Promise<void> => {
  await createApiCall(
    {
      path: "/v1/auth/register/reset_password_finalize",
      method: "POST",
      body: formValues,
    },
    {
      getMessage: {
        success: () => "You changed password successfully, please login.",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();
};

export const refreshAccessToken = async (
  accessToken: string,
  refreshToken: string
): Promise<{ refreshToken: string; accessToken: string } | null> => {
  try {
    const resp = await createApiCall(
      {
        path: "/v1/users/tokens/refresh",
        method: "POST",
        body: {
          accessToken,
          refreshToken,
        },
      },
      {
        getMessage: {
          success: () => "",
          error: () => "", // Don't show error message for token refresh
        },
      }
    )();

    if (resp && resp.data && resp.data.accessToken && resp.data.refreshToken) {
      return {
        refreshToken: resp.data.refreshToken,
        accessToken: resp.data.accessToken,
      };
    }

    return null;
  } catch (error) {
    // Silently fail - the interceptor will handle sign out
    console.warn("Token refresh failed:", error);
    return null;
  }
};
